const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getActorGuid(actor: any): string | null {
  const candidates = [
    actor?.guidId,
    actor?.actorGuidId,
    actor?.acteurGuidId,
    actor?.actorId,
    actor?.acteurId,
    actor?.id,
  ];
  return candidates.find(candidate => typeof candidate === 'string' && GUID_PATTERN.test(candidate)) ?? null;
}

export function getActorNumericId(actor: any): number | null {
  const candidates = [actor?.numericId, actor?.actorNumericId, actor?.acteurNumericId, actor?.id];
  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined || candidate === '') continue;
    const numericId = Number(candidate);
    if (Number.isInteger(numericId) && numericId >= 0) return numericId;
  }
  return null;
}
